



























































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import ProductState from '@/components/Products/ProductState.vue';
import DepositOverdraftSettings from '@/models/Products/ProductSettings/DefaultSettings/Overdraft/DepositOverdraftSettings';
import DepositOverdraftSettingsEditDialog from '@/components/Products/ProductSettings/DefaultSettings/Overdraft/DepositOverdraftSettingsEditDialog.vue';
import EntityType from '@/models/Shared/EntityType';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'DepositOverdraftSettingsRead', components: { ProductState, DepositOverdraftSettingsEditDialog } })
export default class extends SaascadaVueFieldGroup {

    EntityType = EntityType;
    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: DepositOverdraftSettings;

    @Prop({required: true})
    entityType: EntityType;

    get settingsAvailable() {
        return (this.settings !== undefined);
    }

}
